import React, { useState } from 'react';
import LogViewer from '../components/logs/LogViewer';
import ChatBox from '../components/chat/ChatBox';
import ChatContext from '../store/ChatContext';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';


const ChatContent = () => {

  const [showLogs, setShowLogs] = useState(true); // Show logs by default
  const chatCtx= useContext(ChatContext);
  const toggleLogs = () => {
    setShowLogs(prev => !prev);
  };
  
  const {chatIdentifier} = useParams();
 
  return (
    <div className="h-full overflow-hidden flex relative">
	
	<div className={`flex flex-col w-full`}>
	
     <ChatBox />
    </div>
	
	{/* Logs panel - slide in/out based on showLogs state */}
{/* <div 
  className={`h-full bg-white border-l border-gray-200 overflow-hidden transition-all duration-300 ease-in-out ${
    showLogs ? 'w-80' : 'w-0'
  }`}
>
  <div className={true ? 'block w-full h-full' : 'hidden'}>
    <LogViewer connectionId={chatIdentifier ? chatIdentifier : chatCtx.connectionId} />
  </div>
</div> */}

      {/* Toggle button for the logs panel - positioned absolutely */}
      {/* <button 
        onClick={toggleLogs}
        className={`absolute top-1/2 transform -translate-y-1/2 z-10 ${
          showLogs ? 'right-80' : 'right-0'
        } bg-gray-100 hover:bg-gray-200 rounded-l p-1 border border-r-0 border-gray-300 transition-all duration-300`}
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          className="h-5 w-5" 
          fill="none" 
          viewBox="0 0 24 24" 
          stroke="currentColor"
        >
          {showLogs ? (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          ) : (
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          )}
        </svg>
      </button> */}
    </div>
  );
};

export default ChatContent;
